type Point = Pick<PointerEvent, 'clientX' | 'clientY'>

export const getDistance = (firstPoint: Point, secondPoint: Point): number =>
    Math.hypot(firstPoint.clientX - secondPoint.clientX, firstPoint.clientY - secondPoint.clientY)

// Zooms content out to fit its container, but never above its own size.
export const getFitZoom = (containerWidth: number, contentWidth: number): number =>
    Math.min(containerWidth / contentWidth, 1)

export const getPinchedZoom = (
    startZoom: number,
    startDistance: number,
    distance: number,
    minZoom: number,
    maxZoom: number,
): number => {
    const pinchedZoom = startZoom * (distance / startDistance)

    return Math.min(Math.max(pinchedZoom, minZoom), maxZoom)
}

/**
 * Returns how far to scroll to keep a point in place while zooming by ratio. Position is the distance of that point from the
 * start of the zoomed content, in the current zoom.
 */
export const getZoomAnchorScrollDelta = (position: number, ratio: number): number => position * ratio - position
